<template>
  <v-container class="mt-10 mb-10">
    <v-row>
      <v-col cols="12">
        <h2 class="text-center">Nuestra App</h2>
        <hr class="hr-k my-8">
        <v-container>
          <v-row no-gutters class="">
            <v-col sm="12" md="8" offset-md="2">
              <p class="cuerpo-texto text-center">Kefuri es una aplicación móvil para dar aviso de posibles <b> donantes de órganos  </b> a la Unidad de Procuramiento desde Urgencia y UCI. El personal clínico de dichas unidades ingresan sólo 4 variables y aprietan Alertar, que hace una llamada automática a Procuramiento. El piloto se desarrolló en alianza con la Fundación para la <b>Transferencia Tecnológica </b> y <b>el Hospital del Salvador </b>, financiado por Corfo.</p>
            </v-col>
            <v-col cols="12" sm="8" md="5" class="mx-auto pt-10">
              <img class="img-fluid" src="../assets/img/vector-1.png">
            </v-col>
          
          </v-row>
          <v-row 
            class="mt-10"
          >
            <v-col cols="12" sm="6" md="4"
              v-for="(app, index) in apps"
              :key="index"
            >
                <v-card class="pa-0 bg-light" elevation="0">
                  <v-row class=" align-center">
                    <v-col cols="2" md="3" lg="2" class="pa-0">
                      <v-avatar size="60px" class="rounded" color="cyan">
                        <v-icon class="white--text">
                          {{ app.icon}}
                        </v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="9" lg="10" class="px-3 py-0">
                      <h4>{{app.name}}</h4>
                    </v-col>

                  </v-row>
                </v-card>
                
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OurApp',
  data() {
    return {   
      apps:[
        {icon:'mdi-bell-ring', 
        name: 'Rápido y fácil aviso de Urgencia', 
        p:''},
        {icon:'mdi-comment-check-outline', 
        name: 'Interconexión Urgencia-UCI- Procura', 
        p:''},
        {icon:'mdi-clipboard-check', 
        name: 'Control de información y gestión de las unidades de procura', 
        p:''},
        ]
    }
  },
}
</script>

<style scoped lang="sass">
  h4
    font-size: 0.9em  
</style>